<template>
  <div class="el-upload">
    <el-form>
      <el-upload :disabled="isDisabled" :limit="limitNumber" action="" accept="image/*" :http-request="uploadFile"
        list-type="picture-card" :auto-upload="true" :show-file-list="false" :on-preview="handlePictureCardPreview"
        :on-exceed="handleExceed" :before-remove="beforeRemove" ref="upload" :style="{ width: width, height: height, }">
        <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
        <div class="addbox" v-if="!imageUrl && !imageUrl2">
          <img src="../../assets/icon_add_24hui@2x.png" alt="" class="addicon" />
        </div>
        <div style="position: relative;width:106px;height: 106px;" v-else>
          <img :src="imageUrl || imageUrl2" width="100%" height="100%" />
          <div @click.stop="handleRemove()" class="close">
            <i class="el-icon-close" style="color: #2d46ee;font-size: 16px;"></i>
          </div>
        </div>

      </el-upload>
      <!--
        <el-form-item>
          <el-button size="small" type="primary" style="margin-top: 20px;" @click="submitUpload">点击上传</el-button>
        </el-form-item>
        -->
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
// import { uploadImg, delUpIamge } from '@/api/publicSeries'
export default {
  props: {
    limitNumber: {
      type: Number,
      default: 100
    },
    fileList: {
      type: Array,
      default: () => []
    },
    showAddIcon: {
      type: Boolean,
      default: true
    },
    imageUrl: String,
    width: {
      type: String,
      default: '64px'
    },
    height: {
      type: String,
      default: '64px'
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    limitNumber(val, vall) {
      console.log('limitNumber', val, vall)
    },
    imageUrl: {
      handler(newVal, oldVal) {
        console.log(newVal)
        this.imageUrl2 = newVal
      },
      deep: true
    }
  },
  data() {
    return {
      imageUrl2: '',
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  created() {
    console.log(this.styleObject)
  },
  methods: {
    submitUpload() { this.$refs.upload.submit() },
    uploadFile(e) {
      const file = e.file
      const size = file.size / 1024 / 1024
      console.log(size)
      if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif')) {
        this.$message.error('请上传格式为image/png, image/jpg, image/jpeg的图片, image/gif的图片')
        // this.$notify.warning({
        //   title: '警告',
        //   message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        // })
        return
      } else if (size > 2) {
        this.$message.error('图片大小必须小于2M')
        // this.$notify.warning({
        //   title: '警告',
        //   message: '图片大小必须小于2M'
        // })
        return
      } else {
        const params = new FormData()
        params.append('file', file) // 图片
        console.log(params)
        this.$api.uploadFiles(params).then(res => {
          if (res.code === 0) {
            this.$message.success('上传成功')
            this.imageUrl2 = this.ImgHttps + res.data.url
            this.$emit('getUrl', this.imageUrl2)
          } else {
            this.$message.error('上传失败')
          }
        })
      }
    },
    // 删除图片
    handleRemove(file, index) {
      this.imageUrl2 = ''
      this.$emit('getUrl', this.imageUrl2)
    },
    // 图片上传超过数量限制
    handleExceed(files, fileList) {
      this.$message.error('图片数量超出限制!')
      console.log(files, fileList)
    },
    // 删除图片
    beforeRemove(file, fileList) {
      const url = file.url
      this.$emit('handleRemove', url)
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.close {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #2d46ee;
  border-radius: 50%;
  opacity: 1;
  position: absolute;
  top: -8px;
  right: -4px;
  z-index: 999;
  text-align: center;
  line-height: 16px;
  font-weight: 800;
}

::v-deep .el-dialog .el-dialog__header {
  border-bottom: none;
}

::v-deep .el-upload--picture-card {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #c0c0cc;
  border-radius: 3px;
  line-height: normal;
}

::v-deep .addbox {
  width: 100%;
  height: 100%;
  background: transparent;
  // border: 1px solid #C0C0CC;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* margin-left: 20px; */
}

::v-deep .addicon {
  width: 24px;
  height: 24px;
}
</style>
  